/* eslint-disable prettier/prettier */
/* eslint-disable arrow-body-style */
import React, { memo } from 'react';
import { Icon } from 'tea-component';
// @ts-ignore
import { useIntl } from 'umi';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { noop } from '@/pages/home/utils/utils';
import {
  IStatusImageItemProps,
  IStatusImage,
  ImageStatus,
  ImageError,
} from '@/pages/home/components/ImagesUploader/types.d';

const StatusImageItem: React.FC<IStatusImageItemProps> = (props) => {
  const { status } = props;

  const { formatMessage = noop } = useIntl();

  const getProgress = (progress: number | undefined): number => {
    const isNumber = typeof progress === 'number';
    const flag1 = (progress as number) > 0 && (progress as number) < 100;
    const flag2 = progress === 0 || progress === 100;
    return isNumber && (flag1 || flag2) ? progress : 100;
  };

  /**
   * 获取指定图片错误类型对应的错误信息
   * @param error 图片错误类型
   * @param errorMsg 图片错误信息
   * @returns 图片错误信息
   */
  const getErrorMsg = (
    error: ImageError | undefined,
    errorMsg: string | undefined,
  ): string => {
    let msg: string | undefined | void;
    if (error === ImageError.FileFormatError) {
      msg = formatMessage({
        id: 'dbh_feedback_upload_img_incorrect_format_tips',
        defaultMessage: 'Incorrect file format',
      });
    } else {
      msg = errorMsg;
    }
    return msg || '';
  };

  // 压缩，或者上传状态
  const renderLoadingStatusUI = () => {
    const { progress } = props;

    const safeProgress = getProgress(progress);

    return (
      <div className="upload-box">
        <Icon type="loading" className="font-icon" />
        <div
          className="loading-state"
          style={{
            width: safeProgress === 0 ? 0 : `${safeProgress}%`,
          }}
        />
        <span className="font-text">
          {formatMessage({
            id: 'dbh_feedback_uploading_text',
            defaultMessage: 'Uploading…',
          })}
        </span>
      </div>
    );
  };

  // 压缩成功，或者上传成功状态
  const renderSuccessStatusUI = () => {
    const { src, onDelete = noop } = props;

    return (
      <div className="unloadModal-showImg">
        <img
          src={src}
          className="unloadModal-showImg-img"
          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        />
        <i
          onClick={() => {
            onDelete?.(props);
          }}
        >
          <SvgIcon type="clonse" className="unloadModal-showImg-clonse" />
        </i>
      </div>
    );
  };

  // 错误状态、校验错误、压缩报错、上传报错
  const renderErrorStatusUI = () => {
    const { error, errorMsg, onDelete = noop } = props;

    return (
      <div className="erry-box" style={{ position: 'relative' }}>
        <SvgIcon type="erry-icontip" className="font-icon" />
        <span className="font-text">{getErrorMsg(error, errorMsg)}</span>
        <i
          onClick={() => {
            onDelete?.(props);
          }}
        >
          <SvgIcon type="clonse" className="unloadModal-showImg-clonse" />
        </i>
      </div>
    );
  };

  const render = () => {
    if (status === ImageStatus.Loading) return renderLoadingStatusUI();
    if (status === ImageStatus.Success) return renderSuccessStatusUI();
    if (status === ImageStatus.Error) return renderErrorStatusUI();
    return null;
  };

  return render();
};

export { IStatusImageItemProps, IStatusImage, ImageStatus, ImageError };

export default memo(StatusImageItem);
